<section class="stacksBlockContainer" id="block-reviews">
  <div id="settingsTabs" *ngIf="checkSettings()">
    <a (click)="showDataTab()" [ngClass]="checkData() ? 'active' : ''">{{ 'Data' | translate }}</a>
    <a (click)="showStyleTab()" [ngClass]="checkStyle() ? 'active' : ''">{{ 'Style' | translate }}</a>
  </div>

  <!-- Sidebar Icon -->
  <div *ngIf="checkSidebar()" class="blockSidebar" (click)="appendBlock($event)">
    <img src="assets/images/blocks/reviews.svg" alt="Reviews" onerror="this.src='assets/images/blocks/slider.png'" />
    <p>{{ 'Reviews' | translate }}</p>
  </div>

  <!-- ─── Shared review-cards template ─────────────────────────────────── -->
  <ng-template #reviewCards>
    <div class="reviews-preview-block" [ngStyle]="getBlockFields(blockId)?.style">
        <div class="reviews-horizontal-container">
          <ul *ngIf="getBlockFields(blockId)?.data?.reviews?.length > 0" class="reviews-scroll-list">
            <li *ngFor="let review of getBlockFields(blockId)?.data?.reviews" class="review-scroll-item">
              <div class="review-card">
                <!-- Stars, image and text are each optional; only what the review has is shown -->
                <div *ngIf="review.rating > 0" class="review-stars">
                  <span *ngFor="let star of stars" class="star" [class.star-filled]="star <= review.rating">&#9733;</span>
                </div>
                <button *ngIf="review.image" type="button" class="review-image"
                        (click)="openReviewImage(review.image); $event.stopPropagation()">
                  <img [src]="review.image" [alt]="review.content || review.author" loading="lazy" />
                </button>
                <p *ngIf="review.content?.trim()" class="review-content">{{ review.content }}</p>
                <hr class="review-divider" />
                <div class="review-author">
                  <strong class="author-name">{{ review.author }}</strong>
                  <span *ngIf="review.verified" class="verified-badge">{{ 'Verified Buyer' | translate }}</span>
                  <span *ngIf="review.date" class="review-date">{{ review.date }}</span>
                </div>
              </div>
            </li>
          </ul>
        <div *ngIf="!getBlockFields(blockId)?.data?.reviews?.length" class="no-reviews-hint">
          <p>{{ 'No reviews yet — click edit to add.' | translate }}</p>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- ─── Review image lightbox (opened through MatDialog) ───────────────── -->
  <ng-template #reviewImageLightbox let-image let-dialogRef="dialogRef">
    <div class="review-lightbox" (click)="dialogRef.close()">
      <button type="button" class="review-lightbox-close" [attr.aria-label]="'Close' | translate" (click)="dialogRef.close()">
        <mat-icon>close</mat-icon>
      </button>
      <img [src]="image" alt="review-img" (click)="$event.stopPropagation()" />
    </div>
  </ng-template>

  <!-- ─── Preview (mobile + website) ─────────────────────────────────────── -->
  <div class="previewReviews previewMobile"
       *ngIf="checkPreview()"
       id="{{ 'blockid' + blockId }}"
       cdkDrag [cdkDragData]="blockId"
       [cdkDragDisabled]="builderType === 'website'">
    <div class="blockControlHandlers" *ngIf="!builderService.globals">
      <div class="editBlock blockActionBtn" (click)="showData(blockId); $event.stopPropagation()">
        <mat-icon>edit</mat-icon>
      </div>
      <div class="blockHandle blockActionBtn" cdkDragHandle>
        <mat-icon>open_with</mat-icon>
      </div>
      <div class="deleteBlock blockActionBtn" (click)="deleteBlock(blockId); $event.stopPropagation()">
        <mat-icon>close</mat-icon>
      </div>
    </div>
    <div class="blockPlaceholder" *cdkDragPlaceholder></div>
    <ng-container *ngTemplateOutlet="reviewCards"></ng-container>
  </div>

  <!-- ─── Data Tab ──────────────────────────────────────────────────────── -->
  <div class="previewFields" *ngIf="checkData()">
  <ul class="reviews-data-list" cdkDropList (cdkDropListDropped)="dropReview($event)">
    <li class="review-list-item"
        *ngFor="let review of getBlockFields(blockId)?.data?.reviews; let i = index; trackBy: trackReview"
        cdkDrag>
      <div class="review-drag-placeholder" *cdkDragPlaceholder></div>

      <div class="review-item-inner">
        <mat-accordion class="review-accordion" multi>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <!-- Drag handle -->
              <span class="review-drag-handle" cdkDragHandle (click)="$event.stopPropagation()">
                <mat-icon>drag_indicator</mat-icon>
              </span>

              <mat-panel-title>
                <div class="review-header-meta">
                  <span class="review-header-stars">
                    <span *ngFor="let star of stars"
                          class="star-mini"
                          [class.star-filled]="star <= review.rating">&#9733;</span>
                  </span>
                  <span class="review-header-author">{{ review.author }}</span>
                </div>
              </mat-panel-title>

              <!-- Delete button -->
              <button class="review-delete-btn" (click)="deleteReview(blockId, i); $event.stopPropagation()">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </mat-expansion-panel-header>

            <!-- Author Name -->
            <mat-form-field appearance="outline">
              <mat-label>{{ 'Author Name' | translate }}</mat-label>
              <input matInput [(ngModel)]="review.author" />
            </mat-form-field>

            <!-- Rating: clickable stars + dropdown -->
            <div class="rating-editor mb-3">
              <label class="rating-label">{{ 'Rating' | translate }}</label>
              <div class="rating-row">
                <span
                  *ngFor="let star of stars"
                  class="star star-edit"
                  [class.star-filled]="star <= review.rating"
                  (click)="reviewRatingChange(blockId, i, star)">&#9733;</span>
                <mat-form-field appearance="outline" class="rating-select">
                  <mat-select
                    [value]="review.rating"
                    (selectionChange)="reviewRatingChange(blockId, i, $event.value)">
                    <mat-option [value]="0">{{ 'No rating' | translate }}</mat-option>
                    <mat-option [value]="1">1 ★</mat-option>
                    <mat-option [value]="2">2 ★★</mat-option>
                    <mat-option [value]="3">3 ★★★</mat-option>
                    <mat-option [value]="4">4 ★★★★</mat-option>
                    <mat-option [value]="5">5 ★★★★★</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <!-- Review Content -->
            <mat-form-field appearance="outline">
              <mat-label>{{ 'Review Text' | translate }}</mat-label>
              <textarea matInput rows="3" [(ngModel)]="review.content"></textarea>
            </mat-form-field>

            <!-- Review Image -->
            <div class="review-image-field mb-3">
              <label class="rating-label">{{ 'Review Image (optional)' | translate }}</label>
              <!-- Uploading: placeholder with a spinner where the thumbnail will appear -->
              <div *ngIf="isUploading(review)" class="review-image-thumb review-image-loading">
                <mat-spinner diameter="28"></mat-spinner>
              </div>
              <div *ngIf="review.image && !isUploading(review)" class="review-image-thumb">
                <img [src]="review.image" alt="" (click)="openReviewImage(review.image)" />
                <button type="button" class="review-image-remove" [attr.aria-label]="'Remove Image' | translate"
                        (click)="removeReviewImage(blockId, review)">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
              <label class="fileUpload" [class.disabled]="isUploading(review)" [for]="'reviewImage' + blockId + '-' + i">
                {{ 'Choose an Image' | translate }}
                <input type="file" accept="image/*" [id]="'reviewImage' + blockId + '-' + i"
                       (change)="processReviewImage($event, blockId, review)" />
              </label>
            </div>

            <!-- Date -->
            <mat-form-field appearance="outline">
              <mat-label>{{ 'Date (optional)' | translate }}</mat-label>
              <input matInput [(ngModel)]="review.date" />
            </mat-form-field>

            <!-- Verified Toggle -->
            <div class="verified-toggle mb-2">
              <mat-slide-toggle [(ngModel)]="review.verified">
                {{ 'Verified Buyer' | translate }}
              </mat-slide-toggle>
            </div>

          </mat-expansion-panel>
        </mat-accordion>
      </div>
      </li>
    </ul>

    <button class="addItem" (click)="addReview(blockId)">{{ 'Add Review' | translate }}</button>
  </div>

  <!-- ─── Style Tab ──────────────────────────────────────────────────────── -->
  <div class="styleFields" *ngIf="checkStyle()">
    <h4 class="listTitle">{{ 'Layout' | translate }}</h4>
    <mat-divider></mat-divider>
    <ul>
      <li>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Columns' | translate }}</mat-label>
          <mat-select
            [value]="getBlockFields(blockId)?.style?.reviewsColumns || 'twoColumns'"
            (selectionChange)="styleChange('reviewsColumns', blockId, $event, 'select')">
            <mat-option value="oneColumn">{{ 'One Column' | translate }}</mat-option>
            <mat-option value="twoColumns">{{ 'Two Columns' | translate }}</mat-option>
            <mat-option value="threeColumns">{{ 'Three Columns' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
      </li>
    </ul>

    <h4 class="listTitle">{{ 'Spacing' | translate }}</h4>
    <mat-divider></mat-divider>
    <ul>
      <li>
        <mat-label>{{ 'Padding Top' | translate }}</mat-label>
        <mat-slider showTickMarks discrete max="100" min="0" step="1">
          <input matSliderThumb
            [ngModel]="getBlockFields(blockId)?.style?.['padding-top']?.slice(0, -2)"
            (change)="styleChange('padding-top', blockId, $event, 'slider')" />
        </mat-slider>
      </li>
      <li>
        <mat-label>{{ 'Padding Bottom' | translate }}</mat-label>
        <mat-slider showTickMarks discrete max="100" min="0" step="1">
          <input matSliderThumb
            [ngModel]="getBlockFields(blockId)?.style?.['padding-bottom']?.slice(0, -2)"
            (change)="styleChange('padding-bottom', blockId, $event, 'slider')" />
        </mat-slider>
      </li>
    </ul>
  </div>

</section>
